import api from '@/libs/axiosInstance';
import type { ApiResponse, UnfinishedPayoutsSummary } from '@fluenceur/types';
import { useQuery } from '@tanstack/react-query';

/**
 * Nested under the payout list key on purpose: every action that invalidates
 * `['payoutBatches']` (a cancel, a refused continue) changes what is left to
 * finish, and refreshes this summary without having to know it exists.
 */
export const UNFINISHED_PAYOUTS_SUMMARY_QUERY_KEY = ['payoutBatches', 'unfinishedSummary'] as const;

const fetchUnfinishedPayoutsSummary = async (): Promise<UnfinishedPayoutsSummary> => {
  const { data } = await api.get<ApiResponse<UnfinishedPayoutsSummary>>(
    '/dashboard/payouts/unfinished-summary'
  );

  if (!data.success || !data.data) {
    throw new Error(data.message || 'Failed to fetch unfinished payouts');
  }

  return data.data;
};

/** The payouts the brand started and has not paid yet, summed for one notice. */
export const useUnfinishedPayoutsSummaryQuery = () =>
  useQuery<UnfinishedPayoutsSummary, Error>({
    queryKey: UNFINISHED_PAYOUTS_SUMMARY_QUERY_KEY,
    queryFn: fetchUnfinishedPayoutsSummary,
  });
